import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
	DynamicFormComponent,
	DynamicFormControlComponent,
	FormulaInputComponent,
	GpsInputComponent,
	SignatureButtonComponent,
	SignatureComponent
} from './components';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared';
import { SearcheableSelectInputComponent } from './components/searcheable-select-input/searcheable-select-input.component';
import { SearcheableSelectComponent } from './components/searcheable-select';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { FormActivateGuard, FormDeactivateGuard } from './guard';
import {
	DotNetFormulaDataProvider,
	LastFieldInteractionService,
	NormalizeFormValuesForDatabaseService,
	PreviousRecordService,
	RecalculateFormulaService,
	UnsavedChangesService
} from './services';
import { FormControlTypeProviderService } from './factories/form-control-type-provider';
import { DatePickerModalComponent } from './components/date-picker-modal';
import { NumericInputComponent } from './components/numeric-input';
import { EntryPreviewComponent } from './components/entry-preview';
import { ColumnInformationService } from './validations';

@NgModule({
	declarations: [
		DynamicFormComponent,
		DynamicFormControlComponent,
		SearcheableSelectInputComponent,
		SearcheableSelectComponent,
		DatePickerComponent,
		DatePickerModalComponent,
		FormulaInputComponent,
		NumericInputComponent,
		GpsInputComponent,
		SignatureButtonComponent,
		EntryPreviewComponent,
		SignatureComponent
	],
	imports: [CommonModule, ReactiveFormsModule, FormsModule, IonicModule, SharedModule],
	exports: [DynamicFormComponent, DynamicFormControlComponent, SignatureButtonComponent, EntryPreviewComponent],
	providers: [
		UnsavedChangesService,
		FormActivateGuard,
		FormDeactivateGuard,
		FormControlTypeProviderService,
		PreviousRecordService,
		RecalculateFormulaService,
		DotNetFormulaDataProvider,
		LastFieldInteractionService,
		NormalizeFormValuesForDatabaseService,
		ColumnInformationService
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DynamicFormModule {}
